/**
 * Bezettingsgraad's key figure for Maandrapport's Overzicht: the figure Bezettingsgraad's own Overzicht tile
 * "Bezettingsgraad dit jaar" shows, the share of the fleet's crane-days on rent from 1 January up to its snapshot
 * day, with the same period of the year before. Read from that app's `overzicht` section (`ytd.years`, a compact
 * table of year and rate).
 */

import { rows } from "../bezetting/renderer/data";
import * as fmt from "../bezetting/renderer/fmt";
import type { BezettingFigure } from "./contract";

interface YtdYear {
  readonly year: number;
  readonly rate: number | null;
}

interface OverzichtShape {
  readonly as_of?: string;
  readonly ytd?: {
    readonly to?: string;
    readonly years?: {
      readonly cols: readonly string[];
      readonly rows: readonly (readonly unknown[])[];
    };
  };
}

/** The figure, or null without the section or without this year in it. */
export function bezettingFigure(section: Record<string, unknown> | null): BezettingFigure | null {
  const ov = section as OverzichtShape | null;
  const table = ov?.ytd?.years;
  if (!table || !Array.isArray(table.cols) || !Array.isArray(table.rows)) {
    return null;
  }
  const to = ov?.ytd?.to ?? ov?.as_of ?? null;
  const year = fmt.dates.year(to ?? ov?.as_of);
  if (year === null) {
    return null;
  }
  const byYear = new Map(rows<YtdYear>(table).map((r) => [r.year, r.rate]));
  const rate = byYear.get(year) ?? null;
  return {
    rate: fmt.isNum(rate) ? rate : null,
    lastYear: fmt.isNum(byYear.get(year - 1)) ? (byYear.get(year - 1) ?? null) : null,
    to,
  };
}
